module.exports = __webpack_public_path__ + "static/media/kid01.3403998e.png";